module.exports = __webpack_public_path__ + "media/images/rolllaeden_660-dd943d0d5db253a058aac9ce9f9c62b7.jpg";